
import { defineComponent } from "vue";
import { deleteLink } from "@/api/crud";
import { mapState } from "vuex";

export default defineComponent({
  name: "LTagLinkName",
  data() {
    return {
      flagDelete: false,
    };
  },
  props: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    link: {} as any,
  },
  computed: {
    ...mapState(["token"]),
  },
  methods: {
    handleDelete(e: Event) {
      console.log(e.stopPropagation());
      this.flagDelete = true;
      deleteLink(this.token, this.link._id).then((res) => {
        this.$emit("delete:link", res.link);
      });
    },
    isDelete(e: Event) {
      if (this.flagDelete) e.preventDefault();
    },
  },
});
